import { CallApi, handleJSONResponse, handleResponse } from './common';
import { Release } from '@common/types/release/release';
import { SimpleRelease } from '@common/types/release/simple-release';
import { ReleaseListSummary } from '@common/types/release/release-list-summary';
import { ReleaseArtistRole } from '@common/types/release/release-artist-role';
import SimpleArtist from '@common/types/artist/simple-artist';

const callAPI = CallApi('releases');

export const create = async (
  release: Partial<Release>
): Promise<Partial<Release>> =>
  await callAPI('/draft', 'POST', release).then((response) =>
    handleJSONResponse(response)
  );

export const update = async (
  release: Partial<Release>
): Promise<Partial<Release>> =>
  await callAPI('/draft', 'PUT', release).then((response) =>
    handleJSONResponse(response)
  );

export const list = async (
  artistId: string,
  status?: string,
  rel?: ReleaseArtistRole
): Promise<SimpleRelease[]> => {
  const url = `/${artistId}/?status=${status || ''}&rel=${
    rel || ''
  }&show_earnings=yes`;

  const response = await callAPI(url, 'GET');

  return handleJSONResponse(response);
};

export const summary = async (artistId: string): Promise<ReleaseListSummary> =>
  await callAPI(`/${artistId}/summary`, 'GET').then((response) =>
    handleJSONResponse(response)
  );

export const takedown = async (
  artistId: string,
  releaseId: string
): Promise<any> =>
  await callAPI(`/${artistId}/${releaseId}`, 'DELETE').then((response) =>
    handleJSONResponse(response)
  );

export const cancel = async (
  artistId: string,
  releaseId: string
): Promise<any> =>
  await callAPI(`/cancel/${artistId}/${releaseId}`, 'GET').then((response) =>
    handleJSONResponse(response)
  );
export const cancelPendingTakedown = async (
  artistId: string,
  releaseId: string
): Promise<any> =>
  await callAPI(`/${artistId}/${releaseId}/cancel-takedown`, 'GET').then(
    (response) => handleJSONResponse(response)
  );

export const updatedTakedown = async (
  artistId: string,
  releaseId: string,
  takedownBody: any
): Promise<any> =>
  await callAPI(`/${artistId}/${releaseId}/delete`, 'POST', takedownBody).then(
    (response) => handleJSONResponse(response)
  );

export const get = async (
  artistId: string,
  releaseId: string
): Promise<Partial<Release>> =>
  await callAPI(`/${artistId}/${releaseId}`, 'GET').then((response) =>
    handleJSONResponse(response)
  );

export const publish = async (
  artistId: string,
  releaseId: string,
  release: Partial<Release>
): Promise<string | void> =>
  await callAPI(`/${artistId}/${releaseId}`, 'POST', release).then((response) =>
    handleResponse(response)
  );

export const validate = async (
  artistId: string,
  releaseId: string
): Promise<{ success: true }> =>
  await callAPI(`/${artistId}/${releaseId}/validate`, 'POST').then((response) =>
    handleJSONResponse(response)
  );

export const validateArtists = async (
  artistId: string,
  releaseId: string
): Promise<SimpleArtist[]> =>
  await callAPI(`/${artistId}/${releaseId}/artists`, 'GET').then((response) =>
    handleJSONResponse(response)
  );

export const regenerate = async (
  artistId: string,
  releaseId: string
): Promise<SimpleArtist[]> =>
  await callAPI(`/${artistId}/${releaseId}/regenerate`, 'POST').then(
    (response) => handleJSONResponse(response)
  );
